import { VideoPlatform } from '../../interfaces/vpip-interface';
import { setOVPTokenService } from './ovp';
import { sendHeartbeat, stopHeartbeat, getEventAsset, getLiveContent, getPreviewAsset, getVODAsset, decorateLicenseRequest, exchangePrefetchToken, } from './playback';
import { setAuthenticationHandler, setConfig } from './playback-config-storage';
export function videoPlatformIntegrationProviderFactory(config, tokenService, authenticationHandler) {
    setOVPTokenService(tokenService);
    setConfig(config);
    setAuthenticationHandler(authenticationHandler);
    return {
        type: VideoPlatform.OVP,
        exchangePrefetchToken: exchangePrefetchToken,
        getEventPlayoutData: getEventAsset,
        getLivePlayoutData: getLiveContent,
        getPreviewPlayoutData: getPreviewAsset,
        getVodPlayoutData: getVODAsset,
        decorateLicenseRequest: decorateLicenseRequest,
        sendHeartbeat: sendHeartbeat,
        stopHeartbeat: stopHeartbeat,
    };
}
//# sourceMappingURL=video-platform-integration-service.js.map